export type InboxReducerState = {
  historyCutoffDays: number;
  isViewingAllErrands: boolean;
  isViewingAllErrandsForRole: boolean;
  caregivers: SystemUser[];
  selectedCaregiver?: SystemUser;
  filters: Record<string, string[]>;
  waitingTimeSortOrder: Record<string, SortOrder>;
  currentSectionPage: Record<string, number>;
  lastVisitedTab: InboxTab;
  isViewingAllSharedQueueErrands: boolean;
};

export type InboxTab = 'errands' | 'appointments' | 'waiting-room';

type InboxAction =
  | { type: 'setHistoryCutoffDays'; numDays: number }
  | { type: 'toggleViewingAllErrands' }
  | { type: 'toggleViewingAllErrandsForRole' }
  | { type: 'selectCaregiverFilter'; caregiver?: SystemUser }
  | { type: 'setFilter'; filter: string; reasons: string[] }
  | { type: 'setSortOrder'; section: string }
  | { type: 'setSectionPage'; section: string; page: number }
  | { type: 'setLastVisitedTab'; tab: InboxTab }
  | { type: 'toggleViewingAllSharedQueueErrands' };

export const initialState: InboxReducerState = {
  historyCutoffDays: 30,
  isViewingAllErrands: false,
  isViewingAllErrandsForRole: false,
  caregivers: [],
  filters: {},
  waitingTimeSortOrder: {},
  currentSectionPage: {},
  lastVisitedTab: window.location.href.includes('appointments') ? 'appointments' : 'errands',
  isViewingAllSharedQueueErrands: true
};

const reducer = (state: InboxReducerState = initialState, action: InboxAction): InboxReducerState => {
  switch (action.type) {
    case 'setHistoryCutoffDays':
      return { ...state, historyCutoffDays: action.numDays };
    case 'toggleViewingAllErrands':
      return {
        ...state,
        isViewingAllErrands: !state.isViewingAllErrands,
        selectedCaregiver: state.isViewingAllErrands ? undefined : state.selectedCaregiver,
        currentSectionPage: {}
      };
    case 'toggleViewingAllErrandsForRole':
      return {
        ...state,
        isViewingAllErrandsForRole: !state.isViewingAllErrandsForRole,
        currentSectionPage: {}
      };
    case 'selectCaregiverFilter':
      return { ...state, selectedCaregiver: action.caregiver, currentSectionPage: {} };
    case 'setFilter':
      return { ...state, filters: { ...state.filters, [action.filter]: action.reasons }, currentSectionPage: {} };
    case 'setSortOrder':
      return {
        ...state,
        waitingTimeSortOrder: {
          ...state.waitingTimeSortOrder,
          [action.section]: state.waitingTimeSortOrder[action.section] === 'DESC' ? 'ASC' : 'DESC'
        }
      };
    case 'setSectionPage':
      return { ...state, currentSectionPage: { ...state.currentSectionPage, [action.section]: action.page } };
    case 'setLastVisitedTab':
      return { ...state, lastVisitedTab: action.tab };
    case 'toggleViewingAllSharedQueueErrands':
      return {
        ...state,
        isViewingAllSharedQueueErrands: !state.isViewingAllSharedQueueErrands,
        currentSectionPage: {}
      };
    default:
      throw new Error(`Unhandled action type: ${action}`);
  }
};

export default reducer;
